import type { AuthState } from "@/auth/auth.types";
import { MAX_POLL_SEGMENTS, WORKSPACE_ID } from "@/features/session-diagnostics/api/session-diagnostics.api";
import { DEFAULT_MAX_ACTIVE_PLAYERS } from "@/features/session-diagnostics/hooks/use-visible-tiles";

// UX only: the backend decides every request (flag + allowlist + role + revocation).
// Hiding the entry is not the control; a hidden screen that is reached by URL still gets
// the backend's opaque 403.
const featureEnabled = (): boolean => process.env.REACT_APP_DIAGNOSTIC_SESSIONS_ENABLED === "true";

// The workspace the sidebar and the mosaic open on. Absent or malformed ⇒ not offered.
const configuredWorkspace = (): string | null => {
    const value = process.env.REACT_APP_DIAGNOSTIC_SESSIONS_WORKSPACE?.trim();
    return value !== undefined && WORKSPACE_ID.test(value) ? value : null;
};

// DA-26: a link (e.g. from VB360) may name the workspace; it is an id, already validated
// by the URL filters, and the backend still authorises it on every read.
const workspaceFor = (fromUrl: string | null): string | null => fromUrl ?? configuredWorkspace();

const maxActivePlayers = (): number => {
    const raw = process.env.REACT_APP_DIAGNOSTIC_SESSIONS_MAX_PLAYERS;
    const value = raw === undefined ? Number.NaN : Number(raw);
    return Number.isInteger(value) && value >= 1 && value <= MAX_POLL_SEGMENTS ? value : DEFAULT_MAX_ACTIVE_PLAYERS;
};

const canOpen = (state: AuthState): boolean => featureEnabled() && state.status === "authenticated";

// The navigation entries need a workspace to open on; a link that carries one does not.
const can = (state: AuthState): boolean => canOpen(state) && configuredWorkspace() !== null;

export const sessionDiagnosticsAccess = { featureEnabled, configuredWorkspace, workspaceFor, maxActivePlayers, canOpen, can };
